import { Alert, Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import { MyModal } from "../../../../components/styled-components";

interface OtpModalProps {
  visible: boolean;
  onOtpSubmit: (otp: string, userID: string) => void;
  incorrectOTP: boolean; // Add a prop to indicate incorrect OTP
}

const OtpModal: React.FC<OtpModalProps> = ({ visible, onOtpSubmit, incorrectOTP }) => {
  const [otp, setOtp] = useState("");
  const [userID, setUserId] = useState("");
  const [isloadingOTP, setIsloadingOTP] = useState(false); // Changed to boolean
  const [refOtp, setRefOtp] = useState("");
  const handleOtpChange = (value: string) => {
    // Allow only numbers
    const regex = /^[0-9]+$/;

    // Check if each character in the value matches the regex
    if (value === "" || value.split("").every((char) => regex.test(char))) {
      setOtp(value);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const storedRefOtp = localStorage.getItem("ref_otp");
      if (storedRefOtp) {
        setRefOtp(storedRefOtp);
        clearInterval(interval); // Clear interval once value is obtained
      }
    }, 1000); // Check every 1 second

    return () => clearInterval(interval); // Clear interval on component unmount
  }, []);

  const handleReset = () => {
    setOtp("");
  };

  const handleSubmit = () => {
    setIsloadingOTP(true); // Set loading to true when confirm is clicked
    onOtpSubmit(otp, userID);
  };

  return (
    <MyModal
      title="กรุณาใส่รหัส OTP เพื่อปลดล็อค Batch"
      visible={visible}
      footer={[
        <Button key="reset" onClick={handleReset}>
          รีเซ็ต
        </Button>,
        <Button key="ยืนยัน" type="primary" onClick={handleSubmit} loading={isloadingOTP}>
          ยืนยัน
        </Button>,
      ]}
    >
      {incorrectOTP && (
        <Alert message="รหัส OTP ไม่ถูกต้อง กรุณาลองอีกครั้ง" type="error" showIcon />
      )}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
        <Input
          style={{ width: "200px", marginRight: "8px", textAlign: "center" }}
          maxLength={6}
          onChange={(e) => handleOtpChange(e.target.value)}
          value={otp}
          placeholder="OTP"
        />
        <Input
          style={{ width: "120px", marginRight: "8px", textAlign: "center" }}
          maxLength={7}
          onChange={(e) => setUserId(e.target.value)}
          value={userID}
          placeholder="User ID (Admin)"
        />
      </div>
      <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        Ref OTP: {refOtp}{" "}
      </p>
    </MyModal>
  );
};

export default OtpModal;
